import yup from '../../../../utils/yup-extended';
import { ONLINE_REPUTATION_CUSTOM_PROMPT_MAX_LENGTH } from '../constants';
import { defaultOnlineReputationSettings } from '../default-settings';
import { OnlineReputationCheckInput } from '../online-reputation-check-input';

export const onlineReputationSettingsSchema = (): yup.SchemaOf<
  OnlineReputationCheckInput['settings']
> => {
  return yup
    .object()
    .shape({
      customPrompt: yup
        .string()
        .nullable()
        .default(defaultOnlineReputationSettings.customPrompt)
        .max(
          ONLINE_REPUTATION_CUSTOM_PROMPT_MAX_LENGTH,
          `Custom prompt must be at most ${ONLINE_REPUTATION_CUSTOM_PROMPT_MAX_LENGTH} characters`,
        )
        .optional(),
    })
    .noExtraProperty()
    .defined();
};
